import { EMPTY_STRING, SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { arcToFixed } from "./arc-to-fixed";

export const arcSpatiumUnit = () => {
  const type = localStorage.getItem(SETTING_UNITS_KEY);
  if (type === UnitType.SI) return 'm';
  if (type === UnitType.IMPERIAL) return 'ft';
  return '';
};

export const arcSpatium = (value?: number | null | string) => {

  const payload = Number(value);
  
  const type = localStorage.getItem(SETTING_UNITS_KEY);

  const request = isNaN(payload) ? EMPTY_STRING : arcToFixed(payload);

  if (type === UnitType.SI) return request  + ' m';

  if (type === UnitType.IMPERIAL) return request + ' ft';

  return EMPTY_STRING;
};